import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HowItWorks from "@/components/HowItWorks";
import BookingForm from "@/components/BookingForm";
import StatsSection from "@/components/StatsSection";
import ServicesSection from "@/components/ServicesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ZonesSection from "@/components/ZonesSection";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";
import FloatingCallButton from "@/components/FloatingCallButton";

export default function HomePage() {
  return (
    <main className="overflow-x-hidden">
      <Header />
      <HeroSection />
      <HowItWorks />
      <BookingForm />
      <StatsSection />
      <ServicesSection />
      <TestimonialsSection />
      <ZonesSection />
      <FaqSection />
      <Footer />
      <FloatingCallButton />
    </main>
  );
}
